import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";

const getVendors = async () => {
    const response = await axios.get("product/vendors", {headers: authHeader()});
    return response.data.result;
};

export const vendorSoftwareApi = {
    getVendors
};
